import { createIcon } from '@chakra-ui/react';

export const Check = createIcon({
  displayName: 'Check',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M9.33839 15.0473L5.59744 11.2299L4.32355 12.5207L9.33839 17.6379L20.1037 6.65276L18.8388 5.362L9.33839 15.0473Z"
      fill="currentColor"
    />
  ),
});
